import { Table, Typography, theme } from "antd";
import { renderInlineMarkdown } from "./inlineMd";

const { Text } = Typography;

interface TableBlockProps {
	headers: string[];
	rows: string[][];
	caption?: string;
}

export default function TableBlock({ headers, rows, caption }: TableBlockProps) {
	const { token } = theme.useToken();

	const columns = headers.map((header, idx) => ({
		title: renderInlineMarkdown(header),
		dataIndex: String(idx),
		key: String(idx),
		render: (value: string) => renderInlineMarkdown(value),
	}));

	const dataSource = rows.map((row, rowIdx) => {
		const record: Record<string, string> = { key: String(rowIdx) };
		row.forEach((cell, colIdx) => {
			record[String(colIdx)] = cell;
		});
		return record;
	});

	return (
		<figure style={{ margin: "16px 0" }}>
			<Table
				columns={columns}
				dataSource={dataSource}
				pagination={false}
				size="small"
				bordered
			/>
			{caption && (
				<figcaption style={{ marginTop: 8, textAlign: "center" }}>
					<Text type="secondary" style={{ fontSize: token.fontSizeSM }}>
						{caption}
					</Text>
				</figcaption>
			)}
		</figure>
	);
}
